function countdown() {

    var defaultOptions = {
        'timezone': "America/New_York"
    };

    let getOptions = function($el) {
        let options = $.extend({}, defaultOptions, $el.data());
        if (options.datetime) {
            options.datetime = new Date(options.datetime);
        }
        else {
            options.datetime = moment.tz(options.time, options.timezone).toDate();
        }
        return options;
    }

    $("#countdown").each(function () {
        var $this = $(this);
        var options = getOptions($this);
        var format = " %-D day%!D, %H:%M:%S";
        $this.countdown(options.datetime)
            .on('update.countdown', function (event) {
                $(this).html(event.strftime(format));
            })
            .on('finish.countdown', function (event) {
                $('#footer .venue span.small-hide').remove();
            });
    });

    $("#countdown2").each(function () {
        var $this = $(this);
        var options = getOptions($this);
        var format = " %-D day%!D, %H:%M:%S";
        $this.countdown(options.datetime)
            .on('update.countdown', function (event) {
                $(this).html(event.strftime(format));
            })
            .on('finish.countdown', function (event) {
                $this.remove();
            });
    });

    $("#countdowndays").each(function () {
        var $this = $(this);
        var options = getOptions($this);
        var format = " 0%-D";
        $this.countdown(options.datetime)
            .on('update.countdown', function (event) {
                $(this).html(event.strftime(format));
            });
    });

    $("#countdowntop").each(function () {
        var $this = $(this);
        var options = getOptions($this);
        var format = " %H:%M:%S";
        $this.countdown(options.datetime)
            .on('update.countdown', function (event) {
                $(this).html(event.strftime(format));
            });
    });

    $("#countdown5").each(function () {
        var $this = $(this);
        var options = getOptions($this);
        var format = '<span class="counter">%D</span> <span class="rspacer">:</span> <span class="counter">%H</span>  <span class="rspacer">:</span> <span class="counter">%M</span> <span class="rspacer">:</span> <span class="counter">%S</span>';
        $this.countdown(options.datetime)
            .on('update.countdown', function (event) {
                $(this).html(event.strftime(format));
            })
            .on('finish.countdown', function (event) {
                $(this).html(event.strftime(format));
            });
    });


    $("#next-event-date-time").each(function () {
        var $this = $(this);
        var options = getOptions($this);
        var format = '"%-D day%!D, %H:%M:%S"';
        $this.countdown(options.datetime)
            .on('update.countdown', function (event) {
                $(this).html(event.strftime(format));
            })
            .on('finish.countdown', function (event) {
                $(this).html(event.strftime(format));
            });
    });

    // Header countdown alternating display
    $("#header .dates-countdown").each(function () {
        var $this = $(this);
        var $container = $this.closest('.dates-container');
        var $dates = $container.find('.dates-text');
        var options = getOptions($this);
        var format = '%-D day%!D %H:%M:%S';

        $this.countdown(options.datetime)
            .on('update.countdown', function (event) {
                $(this).html(event.strftime(format));
            });

        // Alternate every 5 seconds
        var showingDates = true;
        setInterval(function () {
            if (showingDates) {
                $dates.addClass('hidden');
                $this.removeClass('hidden');
            } else {
                $this.addClass('hidden');
                $dates.removeClass('hidden');
            }
            showingDates = !showingDates;
        }, 5000);
    });
}